var Ractive = require('ractive');
var component = module;

  component.exports = {
    onrender: function (options) {
      var self = this;
      var $ = require('jquery'), jQuery = $
      if(ConfigClient&&ConfigClient.InfoKey){
        self.set('login.InfoKey', ConfigClient.InfoKey);
        self.set('InfoKeyClient', ConfigClient.InfoKey);
      }else{
        self.set('login.InfoKey', Client.getLastUserKey());
      }

			if (Global.Callbacks['menu']) {
				Global.Callbacks['menu'].fire('doListCaption', "Profil");
			}			

			if((typeof(Global)=="object")&&(Global.Config)){
				if(Global.Config.LinkHelp){
					this.set('LinkHelp', Global.Config.LinkHelp);
				}
				if(Global.Config.LinkManual){
					this.set('LinkManual', Global.Config.LinkManual);
				}
			}
      console.log(location.hostname);

      self.on('doRefresh', function (e) {
        if(Global&&Global.Session&&Global.Session.Status){
          self.fire('setTab', 'profil');

          var fRequest = {
                Name: "Sql",
                Action: "Query",
                Query: "TT-Profil-Web",
                Payload: {
                  username: Global.Session.UserName,
                  useruid: Global.Session.UserUID,
                  infokey: Global.Session.InfoKey
                },
                Behavior: { Rows: "UserRow", loading: "loading" }
              };
          self.cmd.Data(self, fRequest);          
        }else{
          self.fire('setTab', 'enter');
        }
        self.set('CacheData.Users', Client.getUsers());
      });
      self.on('doLogout', function () {
        self.cmd.Logout(self, function (oData) {
          if(oData.Status){
            setTimeout(function(){ 
							window.location.href = "/";
            }, 800);
          }
        });
      });
      var passwordResetDialog;
      self.on('doPasswordResetShow', function () {
        try {
          var passwordModal = document.getElementById('PasswordResetShow');
          passwordResetDialog = new bootstrap.Modal(passwordModal);
          if(passwordResetDialog){
            self.set("PasswordReset.NewPassword", "");
            self.set("PasswordReset.NewPasswordNotValid", false);
            passwordModal.addEventListener('shown.bs.modal', function () {
              document.getElementById('ResetNewPassword').focus();
            });
            passwordResetDialog.show();            
          }
        } catch (err) {
          alert(err);
        }
      });
      self.on('doPasswordReset', function (iValue) {
        if(!iValue){
          toastr.error("Error", "No Data!");
          return;
        }

        if(!iValue.NewPassword){
          toastr.error("Error", "Password is empty");
          document.getElementById('ResetNewPassword').focus();
          return;
        }

        if(!iValue.NewPasswordRe){
          toastr.error("Error", "Re-Password is empty");
          document.getElementById('ResetRepeatPassword').focus();
          return;
        }

        if(iValue.NewPassword&&iValue.NewPassword!=iValue.NewPasswordRe){
          toastr.error("Error", "Lozinke nisu iste, ponovite postupak");
          document.getElementById('ResetNewPassword').focus();
          return;
        }

        if(iValue&&iValue.NewPassword&&iValue.NewPassword==iValue.NewPasswordRe){
          try {
            var fRequest = {
                  Name: "Sql",
                  Action: "Update",
                  Query: "TT-Profil-ChangePassword",
                  Payload: {
                    UserName: Global.Session.UserName,
                    UserUID: Global.Session.UserUID,
                    Password: iValue.NewPassword,
                    InfoKey: Global.Session.InfoKey
                  },
                  Behavior: { loading: "loading" }
                };
            self.cmd.Data(self, fRequest, function(oData){
              if(oData.Status){
                if(passwordResetDialog){
                  passwordResetDialog.hide();
                }
                toastr.success("uspešno", "Postavljena je nova lozinka");
              }else{
                toastr.error("Error", oData.Error);
              }
            }); 
          } catch (err) {
            toastr.error("Error", err);
          }
        }else{
          toastr.error("Error", "Did not pass check!");
        }
      });
      self.on('doClearReset', function () {
        try {
          localStorage.clear();
          setTimeout(function(){ 
            window.location.href = "#";
            window.location.reload();
          }, 800);
        } catch (err) {
          alert(err);
        }
      });      
      self.fire('doRefresh');
    },
    data: function () {
      return {
        loading: false,
        UserRow: [],
        CacheData: {
          Users: {}
        },
        Config: {
          UserNotFoundTab: 'notfound'
        },
        InfoKeyClient: "",
        PasswordReset: {
          Step: 1,
          NewPasswordNotValid: false,
          NewPassword: ""
        },
        displayName: "enter",
        displayLast: "enter",
        User: {
          InfoKey: "",
          Title: "",
          Email: "",
          UserName: "",
          UserPass: "",
          RememberMe: true
        },
        login: {
          InfoKey: "",
          UserName: "",
          UserPass: "",
          RememberMe: true
        },
				LinkHelp: "",
				LinkManual: "",        
        d: Client.createDisplay(),
        Lng: SiteLng,
        isVisible: function(iInfoKey, iUser){
          if(iInfoKey){
            return (iUser&&iUser.UserName&&iUser.UserName!="visitor"&&iUser.InfoKey==iInfoKey);
          }else{
            return (iUser&&iUser.UserName&&iUser.UserName!="visitor");
          }
        },
        getGroups: function(iValue){
          const myJson = Format.formatXml2Json(iValue);
          //console.log('xml', myJson[0]);
          return (myJson&&0<myJson.length)? myJson[0]:[];
        },
        hasGroupAdmin: function(iValue){
          if(iValue){
            const myJson = Format.formatXml2Json(iValue);

            if(myJson&&0<myJson.length&&myJson[0]){
              for(i=0; i<myJson[0].length; i++){
                if(myJson[0][i][0]=="Admins"){
                  return true;
                }
              }
            }            
          }

          return false;
        }
      }
    }
  }

component.exports.template = {v:4,t:[{p:[1,1,0],t:7,e:"div",m:[{n:"class",f:"container-fluid",t:13}],f:[{p:[2,3,33],t:7,e:"div",m:[{n:"class",f:"page-content",t:13}],f:[{t:4,f:[{p:[4,5,95],t:7,e:"div",m:[{n:"class",f:"card custom-card",t:13}],f:[{p:[5,7,133],t:7,e:"div",m:[{n:"class",f:"card-header",t:13}],f:[{p:[6,9,168],t:7,e:"div",m:[{n:"class",f:"card-title text-uppercase",t:13}],f:[{p:[6,48,207],t:7,e:"i",m:[{n:"class",f:"bi bi-envelope-at",t:13}]}," ",{t:3,r:"session.UserName",p:[6,87,246]}]}]}," ",{p:[8,7,296],t:7,e:"div",m:[{n:"class",f:"card-body",t:13}],f:[{p:[9,9,329],t:7,e:"span",m:[{n:"class",f:"badge bg-info text-uppercase",t:13}],f:[{t:3,r:"session.InfoKey",p:[9,52,372]}]}," ",{p:[9,86,406],t:7,e:"span",m:[{n:"class",f:"badge bg-secondary",t:13}],f:[{t:3,r:"session.InfoName",p:[9,119,439]}]},"  ",{p:[10,9,484],t:7,e:"br"},{p:[10,13,488],t:7,e:"br"}," ",{p:[11,9,502],t:7,e:"div",m:[{n:"class",f:"row",t:13}],f:[{p:[12,11,531],t:7,e:"div",m:[{n:"class",f:"col-sm-8 col-xs-12",t:13}],f:[{p:[13,13,577],t:7,e:"Element-Input",m:[{n:"title",f:"Ime i Prezime",t:13},{n:"value",f:[{t:2,r:"User.Title",p:[13,56,620]}],t:13},{n:"mandatory",f:"true",t:13}]}]}," ",{p:[15,11,698],t:7,e:"div",m:[{n:"class",f:"col-sm-4 col-xs-6",t:13}],f:[{p:[16,13,743],t:7,e:"Element-Input",m:[{n:"title",f:"Email",t:13},{n:"value",f:[{t:2,r:"User.Email",p:[16,48,778]}],t:13},{n:"mandatory",f:"true",t:13}]}]}]}]}," ",{p:[20,7,884],t:7,e:"div",m:[{n:"class",f:"card-footer",t:13}],f:[{p:[21,9,919],t:7,e:"button",m:[{n:"class",f:"btn btn-lg btn-success",t:13}],f:["Snimi"]},"  ",{p:[22,9,988],t:7,e:"button",m:[{n:"class",f:"btn btn-lg btn-outline-primary ex-action",t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doPasswordResetShow\")]"}},t:70}],f:[{t:3,r:"Lng.Page.Access.ResetPasswordShow.Text",p:[22,111,1090]}]},"   ",{p:[23,9,1165],t:7,e:"button",m:[{n:"class",f:[{t:2,r:"Lng.Page.Access.Logout.Class",p:[23,24,1180]}," float-end ex-action"],t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doLogout\")]"}},t:70}],f:[{t:3,r:"Lng.Page.Access.Logout.Text",p:[23,112,1268]}]}]}]}," ",{p:[26,5,1348],t:7,e:"a",m:[{n:"href",f:"javascript:void(0)",t:13},{n:"class",f:"link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover text-decoration-underline",t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doClearReset\")]"}},t:70}],f:[{t:3,r:"Lng.Page.Access.ClearCache.Text",p:[26,192,1535]}]}," ",{p:[28,5,1584],t:7,e:"div",m:[{n:"class",f:"modal fade",t:13},{n:"id",f:"PasswordResetShow",t:13},{n:"data-bs-backdrop",f:"static",t:13},{n:"data-bs-keyboard",f:"false",t:13},{n:"tabindex",f:"-1",t:13},{n:"aria-labelledby",f:"staticBackdropLabel",t:13},{n:"aria-hidden",f:"true",t:13}],f:[{p:[29,7,1761],t:7,e:"div",m:[{n:"class",f:"modal-dialog",t:13}],f:[{p:[30,9,1797],t:7,e:"div",m:[{n:"class",f:"modal-content",t:13}],f:[{p:[31,11,1836],t:7,e:"div",m:[{n:"class",f:"modal-header",t:13}],f:[{p:[32,13,1876],t:7,e:"h5",m:[{n:"class",f:"modal-title",t:13}],f:[{t:3,r:"Lng.ResetPasswordShow.Title",p:[32,37,1900]}]}]}," ",{p:[34,11,1968],t:7,e:"div",m:[{n:"class",f:"modal-body",t:13}],f:[{p:[35,13,2006],t:7,e:"div",m:[{n:"class",f:"mb-3 row",t:13}],f:[{p:[36,15,2044],t:7,e:"label",m:[{n:"for",f:"ResetUserName",t:13},{n:"class",f:"col-sm-3 col-form-label",t:13}],f:["Nalog"]}," ",{p:[37,15,2132],t:7,e:"div",m:[{n:"class",f:"col-sm-9",t:13}],f:[{p:[38,17,2172],t:7,e:"input",m:[{n:"type",f:"text",t:13},{n:"readonly",f:0,t:13},{n:"class",f:"form-control-plaintext",t:13},{n:"id",f:"ResetUserName",t:13},{n:"value",f:[{t:2,r:"session.UserName",p:[38,101,2256]}],t:13}]}]}]}," ",{p:[41,13,2333],t:7,e:"div",m:[{n:"class",f:"mb-3 row",t:13}],f:[{p:[42,15,2371],t:7,e:"label",m:[{n:"for",f:"ResetNewPassword",t:13},{n:"class",f:"col-sm-3 col-form-label",t:13}],f:["Nova Lozinka"]}," ",{p:[43,15,2469],t:7,e:"div",m:[{n:"class",f:"col-sm-9",t:13}],f:[{p:[44,17,2509],t:7,e:"input",m:[{n:"type",f:"password",t:13},{n:"class",f:"form-control",t:13},{n:"id",f:"ResetNewPassword",t:13},{n:"placeholder",f:"Unesite novu lozinku...",t:13},{n:"value",f:[{t:2,r:"PasswordReset.NewPassword",p:[44,127,2619]}],t:13}]}]}]}," ",{p:[47,13,2705],t:7,e:"div",m:[{n:"class",f:"mb-3 row",t:13}],f:[{p:[48,15,2743],t:7,e:"label",m:[{n:"for",f:"ResetRepeatPassword",t:13},{n:"class",f:"col-sm-3 col-form-label",t:13}],f:["Ponovi Lozinku"]}," ",{p:[49,15,2846],t:7,e:"div",m:[{n:"class",f:"col-sm-9",t:13}],f:[{p:[50,17,2886],t:7,e:"input",m:[{n:"type",f:"password",t:13},{n:"class",f:"form-control",t:13},{n:"id",f:"ResetRepeatPassword",t:13},{n:"placeholder",f:"Ponovite novu lozinku...",t:13},{n:"value",f:[{t:2,r:"PasswordReset.NewPasswordRe",p:[50,131,3000]}],t:13}]}]}]}]}," ",{p:[54,11,3104],t:7,e:"div",m:[{n:"class",f:"modal-footer",t:13}],f:[{p:[55,13,3144],t:7,e:"button",m:[{n:"type",f:"button",t:13},{n:"class",f:"btn btn-primary",t:13},{n:"click",f:{x:{r:["@this","PasswordReset"],s:"[_0.fire(\"doPasswordReset\",_1)]"}},t:70}],f:["Promeni"]}," ",{p:[56,13,3276],t:7,e:"button",m:[{n:"type",f:"button",t:13},{n:"class",f:"btn btn-secondary",t:13},{n:"data-bs-dismiss",f:"modal",t:13}],f:["zatvori"]}]}]}]}]}],n:50,x:{r:["format"],s:"_0.IsUser()"},p:[3,5,65]},{t:4,n:51,f:[{p:[62,5,3448],t:7,e:"Element-NoAuth"}],l:1}]}]}],e:{"[_0.fire(\"doPasswordResetShow\")]":function (_0){return([_0.fire("doPasswordResetShow")]);},"[_0.fire(\"doLogout\")]":function (_0){return([_0.fire("doLogout")]);},"[_0.fire(\"doClearReset\")]":function (_0){return([_0.fire("doClearReset")]);},"[_0.fire(\"doPasswordReset\",_1)]":function (_0,_1){return([_0.fire("doPasswordReset",_1)]);},"_0.IsUser()":function (_0){return(_0.IsUser());}}};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Page/Profile.html
// module id = 29
// module chunks = 0